/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 観察時期
 */
export type MeasureTimingEnum =
  (typeof MeasureTimingEnum)[keyof typeof MeasureTimingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeasureTimingEnum = {
  CONTACT: 'CONTACT',
  SITE: 'SITE',
  AMBULANCE_ACCOMMODATION: 'AMBULANCE_ACCOMMODATION',
  IN_AMBULANCE: 'IN_AMBULANCE',
  TRANSPORTING: 'TRANSPORTING',
  HOSPITAL_ARRIVAL: 'HOSPITAL_ARRIVAL',
  BEFORE_HOSPITAL_ARRIVAL: 'BEFORE_HOSPITAL_ARRIVAL',
  SITE_DEPARTURE: 'SITE_DEPARTURE',
  OTHER: 'OTHER',
} as const;
